import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import Form from 'flarum/common/components/Form';
import app from 'flarum/forum/app';
import Modal from 'flarum/common/components/Modal';
import Button from 'flarum/common/components/Button';
import Switch from 'flarum/common/components/Switch';
import Select from 'flarum/common/components/Select';
export default class UserRecalculateModal extends Modal {
  constructor() {
    super(...arguments);
    _defineProperty(this, "loading", true);
    _defineProperty(this, "recalculating", false);
    _defineProperty(this, "badges", []);
    // Form state
    _defineProperty(this, "selectedBadgeId", '');
    _defineProperty(this, "noRevoke", true);
    _defineProperty(this, "reapplyActions", false);
  }
  oninit(vnode) {
    super.oninit(vnode);
    this.loadBadges();
  }
  className() {
    return 'UserRecalculateModal Modal--small';
  }
  title() {
    return app.translator.trans('fof-badges.forum.user.recalculate_modal.title');
  }
  async loadBadges() {
    this.loading = true;
    m.redraw();
    try {
      const badges = await app.store.find('badges');
      // Filter to only automatic badges (with trigger_config) that are active
      this.badges = (Array.isArray(badges) ? badges : []).filter(b => {
        if (!b || typeof b.isActive !== 'function') return false;
        if (!b.isActive()) return false;

        // Include automatic badges
        const hasConfig = b.triggerConfig();
        if (hasConfig) return true;

        // Include manual badges with actions (for re-apply)
        const actions = b.actions();
        return actions && (actions.send_notification || actions.add_to_group);
      });
    } catch (error) {
      console.error('Failed to load badges:', error);
      this.badges = [];
    } finally {
      this.loading = false;
      m.redraw();
    }
  }
  content() {
    if (this.loading) {
      return m("div", {
        className: "Modal-body"
      }, m(Form, null, m("p", null, app.translator.trans('fof-badges.forum.loading'))));
    }
    const automaticBadges = this.badges.filter(b => b.triggerConfig());
    const manualBadgesWithActions = this.badges.filter(b => !b.triggerConfig());

    // Build badge options
    const badgeOptions = {
      '': app.translator.trans('fof-badges.forum.user.recalculate_modal.all_badges')
    };
    automaticBadges.forEach(badge => {
      badgeOptions[badge.id()] = badge.name();
    });
    manualBadgesWithActions.forEach(badge => {
      badgeOptions[badge.id()] = "".concat(badge.name(), " (").concat(app.translator.trans('fof-badges.forum.user.recalculate_modal.manual'), ")");
    });
    return m("div", {
      className: "Modal-body"
    }, m(Form, null, m("div", {
      className: "Form-group"
    }, m("label", null, app.translator.trans('fof-badges.forum.user.recalculate_modal.badge_label')), Select.component({
      options: badgeOptions,
      value: this.selectedBadgeId,
      onchange: value => {
        this.selectedBadgeId = value;
      },
      disabled: this.recalculating
    })), m("div", {
      className: "Form-group"
    }, Switch.component({
      state: this.noRevoke,
      onchange: value => {
        this.noRevoke = value;
      },
      disabled: this.recalculating
    }, app.translator.trans('fof-badges.forum.user.recalculate_modal.no_revoke_label')), m("p", {
      className: "helpText"
    }, app.translator.trans('fof-badges.forum.user.recalculate_modal.no_revoke_help'))), m("div", {
      className: "Form-group"
    }, Switch.component({
      state: this.reapplyActions,
      onchange: value => {
        this.reapplyActions = value;
      },
      disabled: this.recalculating
    }, app.translator.trans('fof-badges.forum.user.recalculate_modal.reapply_actions_label')), m("p", {
      className: "helpText"
    }, app.translator.trans('fof-badges.forum.user.recalculate_modal.reapply_actions_help'))), m("div", {
      className: "Form-group"
    }, m(Button, {
      className: "Button Button--primary Button--block",
      loading: this.recalculating,
      disabled: automaticBadges.length === 0 && manualBadgesWithActions.length === 0,
      onclick: () => this.submit()
    }, app.translator.trans('fof-badges.forum.user.recalculate_modal.submit')))));
  }
  async submit() {
    this.recalculating = true;
    m.redraw();
    try {
      const body = {
        userId: this.attrs.user.id(),
        noRevoke: this.noRevoke,
        reapplyActions: this.reapplyActions
      };
      if (this.selectedBadgeId) {
        body.badgeId = this.selectedBadgeId;
      }
      const response = await app.request({
        method: 'POST',
        url: app.forum.attribute('apiUrl') + '/badges/recalculate',
        body
      });
      if (response.success) {
        var _this$attrs$onRecalcu, _this$attrs;
        // Show different message based on what happened
        if (response.reapplied > 0 && response.awarded === 0 && response.revoked === 0) {
          app.alerts.show({
            type: 'success'
          }, app.translator.trans('fof-badges.forum.user.recalculate_reapplied', {
            reapplied: response.reapplied
          }));
        } else {
          app.alerts.show({
            type: 'success'
          }, app.translator.trans('fof-badges.forum.user.recalculate_success', {
            awarded: response.awarded,
            revoked: response.revoked,
            reapplied: response.reapplied
          }));
        }
        (_this$attrs$onRecalcu = (_this$attrs = this.attrs).onRecalculate) == null || _this$attrs$onRecalcu.call(_this$attrs);
        this.hide();
      }
    } catch (error) {
      console.error('Failed to recalculate badges:', error);
      app.alerts.show({
        type: 'error'
      }, app.translator.trans('fof-badges.forum.user.recalculate_error'));
    } finally {
      this.recalculating = false;
      m.redraw();
    }
  }
}
flarum.reg.add('fof-badges', 'forum/components/UserRecalculateModal', UserRecalculateModal);